import { render, staticRenderFns } from "./PlaylistView.vue?vue&type=template&id=65cf934e&scoped=true"
import script from "./PlaylistView.vue?vue&type=script&lang=js"
export * from "./PlaylistView.vue?vue&type=script&lang=js"
import style0 from "./PlaylistView.vue?vue&type=style&index=0&id=65cf934e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cf934e",
  null
  
)

export default component.exports